import script from "./pageTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./pageTeam.vue?vue&type=script&setup=true&lang=js"

import "./pageTeam.vue?vue&type=style&index=0&id=c69de4ee&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c69de4ee"]])

export default __exports__